import { Field } from './Field';
import { ISingleField } from './ISingleField';
import { ComparisonType } from './ComparisonType';

export class SingleFullTextField extends Field implements ISingleField<string> {
  public value: string;

  constructor(name: string, description: string, value: string = null, comparisonType: ComparisonType = null) {
    super(name, description, SingleFullTextField.typeName(), comparisonType);
    this.value = value;
  }

  public static typeName(): string {
    return "io.indexed.domainmodel.search.advanced.SingleFullTextField";
  }
}
